import { useState } from 'react';

const useRepaymentInfoBottomSheet = () => {
  const [openInfoBottomSheet, setOpenInfoBottomSheet] =
    useState<boolean>(false);

  const handleClickOpenInfoBottom = () => {
    setOpenInfoBottomSheet(true);
  };

  const handleClickCloseInfoBottom = () => {
    setOpenInfoBottomSheet(false);
  };

  return {
    openInfoBottomSheet,
    setOpenInfoBottomSheet,
    handleClickOpenInfoBottom,
    handleClickCloseInfoBottom,
  };
};

export default useRepaymentInfoBottomSheet;
